import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import lgVideo from 'lightgallery/plugins/video';
import { GalleryData, GalleryFile } from 'src/app/features/restaurants/models/Gallery';
import { ReviewService } from 'src/app/features/restaurants/services/Reviews.service';
import { Record } from 'src/app/features/restaurants/models/List.GuestReviews';
import { GuestsReviewService } from 'src/app/features/guests-reviews/services/guests-review.service';
import Swal from 'sweetalert2';
import { ReportContentResolveFormComponent } from 'src/app/features/reported-content/components/report-content-resolve-form/report-content-resolve-form.component';
import { MatDialog } from '@angular/material/dialog';
import { ReportContentService } from 'src/app/features/reported-content/services/ReportContent.service';


@Component({
  selector: 'app-guest-review-details',
  templateUrl: './guest-review-details.component.html'
})
export class GuestReviewDetailsComponent implements OnInit {
  @Input() restaurantId!: any;
  @Input() selectedReviewId!: string;

  // If Details opens from Guests Review Component
  @Input() isGuestsReview!: boolean;
  btnLoading = false;

  // If Details opens from Reported content
  @Input() isReported = false;

  review!: Record;// reviewDetails;
  dataLoading = false;
  @Output() close = new EventEmitter<boolean>();

  // image file
  avatar: any;
  avatarSrc!: string;
  maxFileSize = 0.8;
  fileTypeError = false;
  fileSizeError = false;

  Readmore = false;

  settings = {
    counter: true,
    plugins: [lgVideo],
    selector: '.view-btn',
  };

  galleryData!: GalleryData;

  showHistory = false;

  constructor(
    private translate: TranslateService,
    private service: ReviewService,
    private reportContentService: ReportContentService,
    private guestsReviewService: GuestsReviewService,
    private dialog: MatDialog,
  ) {
    // super(service, translate);
  }

  ngOnInit(): void {
    this.getDetails();

    this.service.refreshList.subscribe(data => {
      if (data) {
        this.getDetails();
      }
    });
    this.service.closeDetails.subscribe(data => {
      if (data) {
        this.close.emit();
        this.service.closeDetails.next(false);
      }
    });
  }
  ngOnDistroy() {
    this.service.refreshList.unsubscribe();
    this.service.closeDetails.unsubscribe();
  }

  getDetails() {
    this.dataLoading = true;
    if (this.selectedReviewId) {
      this.service.GetDetails(this.selectedReviewId, this.restaurantId).subscribe(
        (data: any) => {
          this.dataLoading = false;
          if (data) {
            this.review = data as Record;
          }
        },
        (error: any) => {
          this.dataLoading = false;
        });
    }
  }


  videoType(item: GalleryFile) {
    return JSON.stringify({
      "source": [
        {
          "src": item.filePath,
          "type": item.type.toLowerCase() + '/' + item.extension
        }
      ],
      "attributes": {
        "preload": false,
        "playsinline": true,
        "controls": true
      }
    })
  }

  HideReview(isHide: boolean) {
    let isHidden = !isHide;

    Swal.fire({
      title: this.translate.instant('swalMsg.Areyousure'),
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yes'),
      cancelButtonText: this.translate.instant('swalMsg.No')
    }).then((result) => {
      if (result.value) {
        this.btnLoading = true;
        this.guestsReviewService.HideReview(this.selectedReviewId, isHidden).subscribe((res: any) => {
          let msg = ''
          if (isHide) {
            msg = this.translate.instant('reviews.This Review is UnHidden Successfully')
          } else {
            msg = this.translate.instant('reviews.This Review is Hidden Successfully')
          }
          this.getDetails();
          this.btnLoading = false;
          Swal.fire({
            title: this.translate.instant('swalMsg.Success'),
            text: msg,
            icon: 'success',
            confirmButtonText: this.translate.instant('swalMsg.Ok')
          }).then((result) => {

            this.guestsReviewService.refreshList.next(true);
          })
        },
          (error: any) => {
            this.btnLoading = false;
            Swal.fire({
              title: this.translate.instant('swalMsg.Failed'),
              text: error.detail,
              icon: 'error',
              confirmButtonText: this.translate.instant('swalMsg.Ok')
            })
          });
      }
    })

  }



  openResolveForm() {
    const dialogRef = this.dialog.open(ReportContentResolveFormComponent, {
      width: '560px',
      data: { record: this.review }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.service.refreshList.next(true);
        this.reportContentService.refreshList.next(true);
      }
    });
  }
}
